import { render, staticRenderFns } from "./PaymentMethodItemIcon.vue?vue&type=template&id=aecbc1c4&scoped=true&"
import script from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
export * from "./PaymentMethodItemIcon.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentMethodItemIcon.vue?vue&type=style&index=0&id=aecbc1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecbc1c4",
  null
  
)

export default component.exports